import { Box, Divider } from '@redbubble/design-system';
import { defineMessages, IntlShape, injectIntl } from '@redbubble/next/intl';
import React from 'react';
import {
  carbonNeutralIcon,
  ethicalPolicyUrl,
  helpCenterUrl,
  localSupportIcon,
  securePaymentIcon,
  securePaymentsHelpUrl,
  shippingHelpUrl,
  shippingIcon,
  TrustSignal,
  TrustSignalProps,
} from '../../../../components/TrustSignal';

import styles from './TrustSignalsGroup.module.scss';

export const messages = defineMessages({
  ethicalPolicy: {
    defaultMessage: 'Ethical Policy',
  },
  ethicalPolicyDescription: {
    defaultMessage: 'Investing in programs that help the environment',
  },
  securePayment: {
    defaultMessage: 'Secure Payments',
  },
  securePaymentDescription: {
    defaultMessage: '100% Secure Payment with 256-bit SSL encryption',
  },
  worldWideShipping: {
    defaultMessage: 'Worldwide Shipping',
  },
  worldWideShippingDescription: {
    defaultMessage: 'Available as standard or express delivery',
  },
  superService: {
    defaultMessage: 'Super Service',
  },
  superServiceDescription: {
    defaultMessage: 'Hassle-free returns and friendly customer support',
  },
  learnMore: {
    defaultMessage: 'Learn more',
  },
  trustSignals: {
    defaultMessage: 'Trust signals',
  },
});

interface TrustSignalsGroupProps {
  intl: IntlShape;
  locale: string;
}

export const TrustSignalsGroup = injectIntl(
  ({ intl, locale }: TrustSignalsGroupProps) => {
    const learnMoreText = intl.formatMessage(messages.learnMore);
    const trustSignalsText = intl.formatMessage(messages.trustSignals);

    const signals: TrustSignalProps[] = [
      {
        image: carbonNeutralIcon,
        imageAlt: intl.formatMessage(messages.ethicalPolicy),
        title: intl.formatMessage(messages.ethicalPolicy),
        description: intl.formatMessage(messages.ethicalPolicyDescription),
        link: ethicalPolicyUrl(locale),
        linkText: learnMoreText,
      },
      {
        image: securePaymentIcon,
        imageAlt: intl.formatMessage(messages.securePayment),
        title: intl.formatMessage(messages.securePayment),
        description: intl.formatMessage(messages.securePaymentDescription),
        link: securePaymentsHelpUrl(locale),
        linkText: learnMoreText,
      },
      {
        image: shippingIcon,
        imageAlt: intl.formatMessage(messages.worldWideShipping),
        title: intl.formatMessage(messages.worldWideShipping),
        description: intl.formatMessage(messages.worldWideShippingDescription),
        link: shippingHelpUrl(locale),
        linkText: learnMoreText,
      },
      {
        image: localSupportIcon,
        imageAlt: intl.formatMessage(messages.superService),
        title: intl.formatMessage(messages.superService),
        description: intl.formatMessage(messages.superServiceDescription),
        link: helpCenterUrl(locale),
        linkText: learnMoreText,
      },
    ];

    return (
      <>
        <Divider marginTop="xs" marginBottom="m" />
        <Box
          className={styles.wrapper}
          element="ul"
          aria-label={trustSignalsText}
        >
          {signals.map((signal) => (
            <TrustSignal
              key={signal.title}
              image={signal.image}
              imageAlt={signal.imageAlt}
              title={signal.title}
              description={signal.description}
              link={signal.link}
              linkText={signal.linkText}
            />
          ))}
        </Box>
      </>
    );
  }
);
